import { apiClient } from '@/api/client';
import type {
  NotificationInboxDto,
  NotificationInboxListFilters,
  NotificationReadAllResult,
  NotificationUnreadCountDto,
  Paged,
} from '@/types/api';

/**
 * 站内消息 / 收件箱 API（PRD-11 §5.1 / backend routes/api.php :853-865）
 *
 * 端点（前缀 /notifications；权限 notification.inbox.self）：
 * - GET   /unread-count        返回 {unread_count, cached_seconds:2}（铃铛轮询）
 * - GET   /                    列表（filter: category / read(bool) / target_type+id / event_code / created_at__gte/lte）
 * - GET   /{id}                详情
 * - PATCH /{id}/read           标记单条已读（幂等：已读再调不报错）
 * - PATCH /read-all            标记全部已读，可带 category 限定，返回 {affected}
 *
 * 不提供删除端点：过期消息后端自动软删（30 天）。
 */
export const notificationInboxApi = {
  unreadCount: () =>
    apiClient.get<unknown, NotificationUnreadCountDto>(
      '/notifications/unread-count',
    ),

  list: (filters: NotificationInboxListFilters = {}) =>
    apiClient.get<unknown, Paged<NotificationInboxDto>>('/notifications', {
      params: filters,
    }),

  show: (id: number) =>
    apiClient.get<unknown, NotificationInboxDto>(`/notifications/${id}`),

  markRead: (id: number) =>
    apiClient.patch<unknown, NotificationInboxDto>(
      `/notifications/${id}/read`,
    ),

  readAll: (category?: number) =>
    apiClient.patch<unknown, NotificationReadAllResult>(
      '/notifications/read-all',
      category ? { category } : {},
    ),
};
